import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../../endpoints';
import { User } from '../../users';

export interface FormResponseUser {
    _id: string;
    responseId: string;
    userId?: string;
    name?: string;
    contractType: number;
    hasValidatedPresence: boolean;
    validatedAt?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface FormResponseUserResponse {
    message: string;
    data: FormResponseUser;
}

export interface FormResponseUsersResponse {
    message: string;
    data: FormResponseUser[];
}

export interface FormResponseUserWithDetails extends Omit<FormResponseUser, 'userId'> {
    userId?: User;
}

export interface FormResponseUsersWithDetailsResponse {
    message: string;
    data: FormResponseUserWithDetails[];
}

// CREATE
export const createAttendedUser = async (data: { responseId: string; userId?: string; name?: string; contractType: number }): Promise<FormResponseUserResponse> => {
    try {
        const response: AxiosResponse<FormResponseUserResponse> = await apiClient.post('/form-response-users', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

export const createAttendedUsers = async (data: {
    responseId: string;
    users: { userId: string; name?: string; contractType: number }[];
}): Promise<FormResponseUsersResponse> => {
    try {
        const response: AxiosResponse<FormResponseUsersResponse> = await apiClient.post('/form-response-users/multiple', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

export const getAttendedUsersByResponseId = async (responseId: string): Promise<FormResponseUsersWithDetailsResponse> => {
    try {
        const response: AxiosResponse<FormResponseUsersWithDetailsResponse> = await apiClient.get(`/form-response-users/${responseId}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// DELETE
export const deleteAttendedUser = async (id: string): Promise<{ message: string }> => {
    try {
        const response: AxiosResponse<{ message: string }> = await apiClient.delete(`/form-response-users/${id}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// SIGN
export const signAttendedUser = async (responseId: string): Promise<FormResponseUserResponse> => {
    try {
        const response: AxiosResponse<FormResponseUserResponse> = await apiClient.post(`/form-response-users/sign/${responseId}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};
